import React from 'react';
import MainLayout from '../../layout/MainLayout';
import Educational from './Educational';
import Skills from './Skills';
import UseTools from './UseTools';

const Resume = () => {
    return (
        <MainLayout>
            <h2><span className='text-blue-500'>R</span>esume</h2>
            <hr />
            <Educational />
            <Skills />
            <UseTools />
        </MainLayout>
    );
};

export default Resume;